export default function(x: any) {
	return JSON.parse(JSON.stringify(x));
}